import { render, staticRenderFns } from "./wenzhang.vue?vue&type=template&id=ea41f272&scoped=true"
import script from "./wenzhang.vue?vue&type=script&lang=js"
export * from "./wenzhang.vue?vue&type=script&lang=js"
import style0 from "./wenzhang.vue?vue&type=style&index=0&id=ea41f272&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea41f272",
  null
  
)

export default component.exports